import { GetRegistry } from 'domain/usecases/registry/remote';
import {
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteGetRegistry implements GetRegistry {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetRegistry.Model>;

  constructor(url: string, httClient: HttpClient<GetRegistry.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  getRegistry = async (
    params: GetRegistry.Params,
  ): Promise<GetRegistry.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{conferenceId}', `${params.conferenceId}`),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
